import { render, staticRenderFns } from "./GExamCreateExamineeSettingSchoolClasses.vue?vue&type=template&id=38a8b558&scoped=true&"
import script from "./GExamCreateExamineeSettingSchoolClasses.vue?vue&type=script&lang=ts&"
export * from "./GExamCreateExamineeSettingSchoolClasses.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "38a8b558",
  null
  
)

export default component.exports